/**
 * Utility to suppress browser install prompts for PWAs
 * while allowing native Android/iOS builds to function normally.
 */

export const disableBrowserInstallPrompts = () => {
  // --- Chrome, Edge, Opera (Desktop & Android) ---
  window.addEventListener("beforeinstallprompt", e => {
    e.preventDefault(); // Block default mini-infobar or install banner
    return false;
  });
};
